<template>
  <div id class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="table-ctn re-back-order">
      <div class="div-table-row re-back-order-title">
        <div class="div-table-cell" style="width: 40%">商品名称</div>
        <div class="div-table-cell" style="width: 40%">赠送清单</div>
        <div class="div-table-cell" style="width: 10%">购买数量</div>
        <div class="div-table-cell" style="width: 10%">提交数量</div>
      </div>
      <div class="re-back-order-main" v-if="tableData.DetailList">
        <div :key="index" class="div-table-row" v-for="(item,index) in tableData.DetailList">
          <div class="div-table-cell" style="width: 40%">
            <div class="image-ctn">
              <img :src="downloadUrl+item.ShowImg" :onerror="defaultImg" />
            </div>
            <span :title="item.Name">{{item.Name}}</span>
          </div>
          <div class="div-table-cell" style="width: 40%">
            <el-tooltip placement="top">
              <div slot="content">
                <div
                  :key="index"
                  v-for="(i,index) in item.GiftGoodsList"
                  style="display: flex;align-items: center"
                >
                  <div class="image-ctn gift-img">
                    <img :src="downloadUrl+i.ShowImg" :onerror="defaultImg" :title="i.Name" />
                  </div>
                  x {{i.RealCount}}
                </div>
              </div>
              <div v-if="item.GiftGoodsList[0]" style="display: flex;align-items: center">
                <div class="image-ctn gift-img">
                  <img
                    :src="downloadUrl+item.GiftGoodsList[0].ShowImg"
                    :onerror="defaultImg"
                    :title="item.GiftGoodsList[0].Name"
                  />
                </div>
                x {{item.GiftGoodsList[0].RealCount}}
              </div>
            </el-tooltip>
          </div>
          <div
            class="div-table-cell"
            style="width: 10%;justify-content: center;padding-left: 0"
          >{{item.BuyCount}}</div>
          <div class="div-table-cell" style="width: 10%;justify-content: center;padding: 5px ">
            <el-input-number
              @change="handleChange"
              v-model="item.Count"
              :min="1"
              :max="item.BuyCount"
              size="mini"
            ></el-input-number>
          </div>
        </div>
      </div>
      <div class="no-data" v-else>无售后商品</div>
    </div>
    <!-- 售后原因 -->
    <div class="re-back-reason">
      <div class="form-item">
        <div class="key">服务类型：</div>
        <div class="value header-content">
          <div
            :key="index"
            v-for="(item,index) in serverType"
            class="add-item"
            style="width: 80px;text-align: center"
            @click.stop="tpggleServerType(item.Value)"
            :class="{'target-checked':serverTypeChoose == index}"
          >{{item.Text}}</div>
        </div>
      </div>
      <div class="form-item">
        <div class="key">提交原因：</div>
        <div class="value">
          <el-select placeholder="请选择" size="mini" v-model="reason">
            <el-option
              v-for="item in reasonList"
              :key="item.Value"
              :label="item.Text"
              :value="item.Value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="form-item">
        <div class="key">问题描述：</div>
        <div class="value">
          <el-input
            v-model.trim="returnReasonDesc"
            type="textarea"
            v-filter-special-char="returnReasonDesc"
            placeholder="请输入内容"
          ></el-input>
        </div>
      </div>
    </div>
    <!-- msg-confirm -->
    <div class="msg-confirm">
      <div class="msg-confirm-title">确认信息</div>
      <div class="msg-confirm-main">
        <div class="form-item">
          <div class="key">返回方式：</div>
          <div class="value">邮寄至 {{address}}</div>
        </div>
        <div class="form-item">
          <div class="key">顾客名称：</div>
          <div class="value">{{tableData.Consignee}}</div>
        </div>
        <div class="form-item">
          <div class="key">电话号码：</div>
          <div class="value">
            <span>{{tableData.Mobile}}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span>提交服务单后，售后专员可能与您电话勾通，请保持手机畅通</span>
          </div>
        </div>
      </div>
    </div>
    <!-- confirm-btn -->
    <div class="msg-confirm-btn">
      <div class="sub-btn" @click="submitApply">确认提交</div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    return {
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      orderCode: "",
      returnReasonDesc: "",
      address: "",
      reason: "",
      reasonList: [],
      serverType: [],
      serverTypeChoose: 0,
      searchData: {
        UserId: this.$util.getLocalStorage("userMsg").EmployeeId,
        OrderType: "",
        OrderId: "",
        OrderGoodRId: ""
      },
      tableData: {}
    };
  },
  activated() {
    this.OrderCode = this.$route.query.OrderCode;
    this.searchData.OrderId = this.$route.query.OrderId;
    this.searchData.OrderType = this.$route.query.OrderType;
    this.searchData.OrderGoodRId = this.$route.query.OrderGoodRId;
    this.getTableData();
    this.getServerType();
    this.getReasonList();
    this.getAddress();
  },
  methods: {
    // 提交
    submitApply() {
      if (!this.tableData.DetailList) {
        this.$util.errorMsg("订单错误，当前无商品");
        return;
      }
      if (!this.reason) {
        this.$util.warningMsg("请选择提交原因");
        return;
      }
      if (!this.returnReasonDesc) {
        this.$util.warningMsg("请填写问题描述");
        return;
      }
      this.$util
        .axiosPost({
          url: `/api/MallSaleOrder/ApplySaleOrderAfterSale`,
          data: {
            orderId: this.searchData.OrderId,
            orderType: this.searchData.OrderType,
            afterSaleType: this.serverTypeChoose,
            afterSaleReason: this.reason,
            afterSaleReasonDesc: this.returnReasonDesc,
            userId: this.searchData.UserId,
            detailList: this.tableData.DetailList
          }
        })
        .then(res => {
          this.$util.successMsg("提交成功");
          setTimeout(() => {
            window.history.back(-1);
          }, 1000);
        })
        .catch(() => {});
    },
    // 获取售后地址
    getAddress() {
      this.$util
        .axiosGet({
          url: `/api/MallSaleOrder/GetAfterSaleAddress`,
          data: {}
        })
        .then(res => {
          let data = res.data;
          this.address = data;
        })
        .catch(() => {});
    },
    // 获取售后退货原因列表
    getReasonList() {
      this.$util
        .axiosGet({
          url: `/api/MallSaleOrder/GetAfterSaleReasonList`,
          data: {}
        })
        .then(res => {
          let data = res.data;
          this.reasonList = data;
        })
        .catch(() => {});
    },
    // 售后服务类型
    getServerType() {
      this.$util
        .axiosGet({
          url: `/api/MallSaleOrder/GetAfterSaleTypeList`,
          data: {}
        })
        .then(res => {
          let data = res.data;
          this.serverType = data;
        })
        .catch(() => {});
    },
    // 售后信息
    getTableData() {
      this.$util
        .axiosGet({
          url: `/api/MallSaleOrder/GetAfterSaleSaleOrder`,
          data: this.searchData
        })
        .then(res => {
          let data = res.data;
          if (data) {
            for (let i = 0; i < data.DetailList.length; i++) {
              data.DetailList[i].Count = 1;
            }
            this.tableData = data;
          } else {
            this.$util.errorMsg("订单错误，当前无商品");
          }
        })
        .catch(() => {});
    },
    back() {
      window.history.back(-1);
    },
    handleChange() {},
    tpggleServerType(key) {
      this.serverTypeChoose = key;
    }
  }
};
</script>
<style lang="less" scoped>
.gift-img {
  img {
    max-width: 50px;
    max-height: 50px;
  }
}
.image-ctn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
}
.msg-confirm-btn {
  text-align: right;
}
.msg-confirm-title {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 10px;
}
.msg-confirm-main {
  padding-left: 50px;
}
.msg-confirm {
  margin-top: 20px;
  border: 1px solid @border3Color;
  padding: 10px;
}
.re-back-reason {
  margin-top: 20px;
  border: 1px solid @border3Color;
  padding: 50px;
  .value {
    flex-grow: 1;
  }
}
.form-item {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}
.re-back-order-title {
  background: @border3Color;
  text-align: center;
  line-height: 36px;
}
.re-back-order-main {
  img {
    max-width: 50px;
    max-height: 50px;
  }
  .div-table-cell {
    padding-left: 10px;
    display: flex;
    align-items: center;
  }
}

.bread-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-content {
  display: flex;
}
.sub-btn {
  text-align: center;
  position: relative;
  width: 135px;
  height: 36px;
  line-height: 36px;
  margin: 8px 10px 0 0;
  background-color: #409eff;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  font-family: arial, "Microsoft YaHei";
  display: inline-block;
  border-radius: 3px;
  cursor: pointer;
}
</style>
